import { createSlice } from "@reduxjs/toolkit"
import types from "../../Actions/types"

const defaultFormularyInitialState = {
  inputs: {},
  sections: {}
}

const initialState = {
  currentFormularyType: null,
  currentFormularyTitle: "",
  preSurvey: defaultFormularyInitialState,
  postSurvey: defaultFormularyInitialState,
  application: defaultFormularyInitialState // Currently only being used for top 3 goals and the rest is legacy implementation
}

const formularySlice = createSlice({
  name: "formulary",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(types.FETCH_FORMULARY, (state, action) => {
      const { currentFormularyType } = state
      const { inputs, sections } = action.payload

      state[currentFormularyType] = {
        sections,
        inputs: inputs.reduce(
          (acum, input) => ({
            ...acum,
            [input.id]: { ...input }
          }),
          {}
        )
      }
    })

    builder.addCase(types.CHANGE_FORMULARY_INPUT, (state, action) => {
      const { currentFormularyType } = state
      const { inputId, value } = action.payload
      const currentFormulary = state[currentFormularyType]
      const currentInput = currentFormulary.inputs[inputId]

      state[currentFormularyType] = {
        ...currentFormulary,
        inputs: {
          ...currentFormulary.inputs,
          [inputId]: {
            ...currentInput,
            value
          }
        }
      }
    })

    builder.addCase(types.SET_CURRENT_FORMULARY, (state, action) => {
      const { formularyType, formularyTitle } = action.payload
      state.currentFormularyType = formularyType
      state.currentFormularyTitle = formularyTitle
    })

    builder.addCase(types.VALIDATE_CURRENT_STEP, (state, action) => {
      const { sectionId, isValid } = action.payload
      const { currentFormularyType } = state
      const currentFormulary = state[currentFormularyType]

      state[currentFormularyType] = {
        ...currentFormulary,
        sections: {
          ...currentFormulary.sections,
          [sectionId]: {
            ...currentFormulary.sections[sectionId],
            isValid
          }
        }
      }
    })

    builder.addCase(types.UPDATE_VISITED_STEP_FLAG, (state, action) => {
      const { stepId, sectionId } = action.payload
      const { currentFormularyType } = state
      const currentFormulary = state[currentFormularyType]

      state[currentFormularyType] = {
        ...currentFormulary,
        sections: {
          ...currentFormulary.sections,
          [sectionId]: {
            ...currentFormulary.sections[sectionId],
            visitedSteps: {
              ...currentFormulary.sections[sectionId].visitedSteps,
              [stepId]: true
            }
          }
        }
      }
    })
  }
})

export default formularySlice.reducer
